import { Box } from "@mui/material";
import CustomTypography from "../Typography";
import { useEffect, useState } from "react";
import emitter from "../../Utils/events/eventBus";
import { catalogName } from "../../Utils/catalogName";

const AccordianSummaryContent = ({
  description,
  name,
  nameHe,
  language,
  isPriclistPage,
  t,
  pricedVariants,
  totalVariants,
  groupedVariantsLength,
  serviceId,
}) => {
  const [priceVariantsCount, setPriceVariantsCount] = useState(pricedVariants);
  useEffect(() => {
    const reciveLatestService = (priced_variants) => {
      setPriceVariantsCount(priced_variants);
    };

    emitter.on(`service-priced-variants-updated-${serviceId}`, reciveLatestService);

    return () => {
      emitter.off(`service-priced-variants-updated-${serviceId}`, reciveLatestService);
    };
  }, [pricedVariants, serviceId]);

  return (
    <Box display="flex" flexDirection="column" gap="2px">
      <CustomTypography
        props={{
          fontWeight: description ? 600 : 400,
          fontSize: description ? "16px" : "14px",
          color: "#2F2B3D",
        }}
      >
        {catalogName(t, name, { ns: "services", nameHe, language })}{" "}
        {isPriclistPage
          ? <bdi>({t("priced_of", { priced: priceVariantsCount, total: totalVariants })})</bdi>
          : <bdi>({t("items_count", { count: Number(groupedVariantsLength) || 0 })})</bdi>}
      </CustomTypography>
      {description && (
        <CustomTypography
          props={{
            color: "#2F2B3DB2",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          {t(description, { ns: "services-description" })}
        </CustomTypography>
      )}
    </Box>
  );
};

export default AccordianSummaryContent;
